<template>
    <div id="app">
        <SignIn />
    </div>
</template>

<script>
import SignIn from './pages/SignIn';

export default {
    name: 'App',
    components: {
        SignIn,
    },
    data() {
        return {};
    },
};
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}
.el-form-item__label {
  color: #000;
}
.sign_form_box .el-upload .el-icon-plus {
    font-size: 28px;
    color: #CEC2AF;
}
.sign_form_box {
    width: 1080px;
    margin: 0 auto;
    text-align: left;
}
.sign_form_box .el-input {
    width: 260px;
}
.sign_form_box .el-textarea {
    width: 425px;
}
.el-textarea .el-input__count {
  line-height: 1;
}
.sign_form_box .el-input__inner,
.sign_form_box .el-textarea__inner {
    padding-left: 8px;
    padding-right: 48px;
}
.operator_box {
    position: relative;
    margin-top: 15px;
    padding: 8px 23px 8px 15px;
    border-radius: 12px;
    width: 460px;
    background: #f4f3f2;
}
.operator_box .form_upload_pic .el-upload {
  background: #fff;
  border-width: 0;
}
.operator_box .el-input__inner {
  border-width: 0;
}
.operator_box .el-form-item {
    margin: 12px 0;
}
.del_opra {
    position: absolute;
    padding: 10px;
    right: 12px;
    bottom: 10px;
    color: #8f8376;
    font-size: 12px;
    line-height: 1;
}
.form_uppic_box {
    display: flex;
}
.uploader_file {
  width: 500px;
}
.file_upload_box {
    display: flex;
    align-items: center;
}
.file_upload_box .placeholder {
    margin: 0 0 0 15px;
    color: #666;
    font-size: 12px;
    line-height: 1.5;
    text-align: left;
}
.form_upload_pic,
.form_oprator_upload_pic {
  font-size: 0;
}
.form_oprator_upload_pic .el-upload {
    background: #fff;
    border-radius: 6px;
    width: 80px;
    height: 80px;
    border: 1px solid #d9d9d9;
}
.form_upload_pic.uploader_size .el-upload{
  width: 150px;
  height: 102px;
}
.form_upload_pic .el-upload {
    width: 120px;
    height: 120px;
    background: #f4f3f2;
    border-radius: 6px;
}
.form_uppic_box .placeholder {
    margin: 15px 0 0 15px;
    color: #666;
    font-size: 12px;
    line-height: 1.5;
}
.agreement_box {
  margin: 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.ck_btn_box {
  margin-right: 3px;
}
.addopra_btnbox {
  margin-top: 50px;
  display: flex;
  align-items: center;
}
.addopra_btnbox .placeholder {
  margin-left: 15px;
    color: #666;
    font-size: 12px;
    line-height: 1.5;

}
.submit_box {
  text-align: center;
}
.submit_box .el-button {
  width: 260px;
  padding-top: 14px;
  padding-bottom: 14px;
}
.verify_modal_form .el-form{
  margin: 0 auto;
  width: 220px;
}
.relative {
  position: relative;
}
.get_code {
  position: absolute;
  top: 0;
  right: 10px;
  color: #D27106;
  font-size: 12px;
}
.get_code .timming {
  color: #666;
}
.verify_modal_form .el-dialog__header {
  padding-top: 25px;
  padding-bottom: 0;
}

.verify_modal_form .el-dialog {
  width: 518px;
}
.verify_modal_form .el-input {
  width: 220px;
}
.verify_modal_form .el-dialog__footer {
  margin-top: -37px;
  padding-bottom: 30px;
}
.verify_modal_form .el-dialog__footer .el-button{
  width: 168px;
}
.verify_modal_form .el-link.el-link--info {
  color: #a8a8a8;
}
.sign_result_modal .el-dialog__title ,
.verify_modal_form .el-dialog__title{
  color: #bbb;
  font-size: 12px;
}
.verify_modal_form .dialog-footer .el-button {
  margin-right: 20px;
}
.sign_result_modal .el-dialog {
  width: 518px;
}
.sign_result_modal_body {
  font-size: 14px;
  text-align: center;
}
.sign_application_code {
  margin: 20px 0;
  font-size: 36px;
}
.sign_result_modal .el-button {
  width: 180px;
}
.el-input__inner:focus,
.el-textarea__inner:focus,
 .el-message-box__input input.invalid,
 .el-message-box__input input.invalid:focus {
  border-color: #F65E00 !important;
}
.el-button {
  border-radius: 4px;
}
.el-button--primary {
  background-color: #3578C7;
  border-color: #3578C7;
}

.el-button--warning {
  background-color: #FE8023;
  border-color: #FE8023;
}
.el-dialog {
  border-radius: 7px;
}
</style>
